module.exports = __webpack_public_path__ + "img/left2.464634c.png";